/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-any

/**
 * A websocket based CrownConnection.
 * Allowed connections: crownJSON / crownMSGPACK.
 *
 * If connection is lost, reconnection is done after specified period.
 */
export class CrownConnectionWebSocket {
  /**
   *
   * @param _authority ip address to connect to
   * @param _protocol connection protocol
   * @param _reconnectIvalMs milli-second interval for reconnection in case of an communication break.
   */
  constructor(_authority, _protocol, _reconnectIvalMs = 2000) {
    this._authority = _authority;
    this._protocol = _protocol;
    this._reconnectIvalMs = _reconnectIvalMs;
  }
  /**
   * see base class
   */


  open() {
    if (this._ws) {
      this._ws.close();

      this._ws = null;
    }

    this._ws = new WebSocket('ws://' + this._authority + '/' + this._protocol);
    this._ws.binaryType = 'arraybuffer';

    this._ws.onerror = _e => {
      this._ws.close();

      console.warn('CrownConnectionWebSocket: web-socket connection interrupted.'); // tslint:disable-line:no-console
    };

    this._ws.onclose = () => {
      if (this._onClose) {
        this._onClose();
      }

      setTimeout(() => {
        // attempt reconnect
        this.open();
      }, this._reconnectIvalMs);
    };

    if (this._onData) {
      this._ws.onmessage = message => this._onData(message.data);
    }

    if (this._onOpen) {
      this._ws.onopen = this._onOpen;
    }
  }
  /**
   * see base class
   */


  setOnOpen(onOpen) {
    this._onOpen = onOpen;

    if (this._ws != null) {
      this._ws.onopen = onOpen;
    }
  }
  /**
   * see base class
   */


  setOnClose(onClose) {
    this._onClose = onClose;
  }
  /**
   * see base class
   */


  setOnData(onData) {
    this._onData = onData;

    if (this._ws != null) {
      this._ws.onmessage = message => onData(message.data);
    }
  }
  /**
   * see base class
   */


  send(data) {
    if (this._ws.readyState === 1) {
      this._ws.send(data);
    }
  }
  /**
   * see base class
   */


  close() {
    this._ws.close();
  }

}
//# sourceMappingURL=CrownConnectionWebSocket.js.map